import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { AppService } from './app.service';

/**
 * This is a custom error handler for Sentry to only show the dialog once in cases of errors occurring in loops.
 */
@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  private isDialogOpen: boolean = false;

  constructor(
    private app: AppService
  ) {}

  /**
   * Handles an error by capturing the exception with Sentry, showing a report dialog,
   * and ensuring the dialog does not open multiple times simultaneously.
   *
   * @param {any} error - The error object to be handled and reported.
   * @return {void} This method does not return a value.
   */
  handleError(error: any): void {
    // Add parts of error messages in this list which should be ignored by Sentry when showing the dialog.
    // When updating, also make changes to ignoredMessages in app/services/sentry.service.ts:201
    const partialErrorsToIgnore: string[] = [
      'ExpressionChangedAfterItHasBeenCheckedError'
    ];
    if ( error instanceof Error && partialErrorsToIgnore.some((partialErrorToIgnore: string): boolean => error.message?.includes(partialErrorToIgnore)) ) {
      return;
    }

    // Only show feedback dialog for actual errors (not warnings)
    const errorMessage: string = error?.message || '';
    const isActualError: boolean = errorMessage.toLowerCase().includes('error');

    if ( !isActualError ) {
      return;
    }

    const eventId: string = Sentry.captureException(error);

    if ( this.isDialogOpen ) {
      return;
    }

    this.isDialogOpen = true;

    // Build optional prefill only when authenticated
    const userPrefill = this.app?.isAuthenticated && this.app?.user ? {
          name: this.app.user.contact_person,
          email: this.app.user.email
        } : undefined;

    // Comment Out to Disable User Feedback Form
    // Sentry.showReportDialog({
    //   eventId: eventId,
    //   ...(userPrefill ? { user: userPrefill } : {}),
    //   lang: 'en'
    // });

    // 12 second cooldown before the next dialog will show if any.
    setTimeout((): void => {
      this.isDialogOpen = false;
    }, 12000);
  }
}
